export type ReferenteType = 'Host' | 'Property Manager' | 'B&B' | 'Agenzia'
export interface Referente {
  id: string
  firstName: string
  lastName: string
  type: ReferenteType
  email: string
  phone: string
  zone: string
  apartments: number
  activeContract: boolean
  hasVikey: boolean
}
export const REFERENTI: Referente[] = [
  {
    id: 'r1',
    firstName: 'Marco',
    lastName: 'Rossi',
    type: 'Host',
    email: 'marco.rossi@example.com',
    phone: '+39 333 1234567',
    zone: 'Milano · Navigli',
    apartments: 3,
    activeContract: true,
    hasVikey: true,
  },
  {
    id: 'r2',
    firstName: 'Laura',
    lastName: 'Bianchi',
    type: 'Property Manager',
    email: 'laura.b@example.com',
    phone: '+39 334 9876543',
    zone: 'Milano · Isola',
    apartments: 8,
    activeContract: true,
    hasVikey: false,
  },
  {
    id: 'r3',
    firstName: 'Giuseppe',
    lastName: 'Verdi',
    type: 'B&B',
    email: 'g.verdi@example.com',
    phone: '+39 335 1122334',
    zone: 'Milano · Centro',
    apartments: 2,
    activeContract: false,
    hasVikey: true,
  },
  {
    id: 'r4',
    firstName: 'Elena',
    lastName: 'Colombo',
    type: 'Agenzia',
    email: 'elena.colombo@example.com',
    phone: '+39 338 4455667',
    zone: 'Milano · Porta Romana',
    apartments: 12,
    activeContract: true,
    hasVikey: false,
  },
  {
    id: 'r5',
    firstName: 'Sophie',
    lastName: 'Laurent',
    type: 'Host',
    email: 'sophie.l@example.com',
    phone: '+39 339 9988776',
    zone: 'Milano · Tortona',
    apartments: 1,
    activeContract: true,
    hasVikey: true,
  },
  {
    id: 'r6',
    firstName: 'Thomas',
    lastName: 'Weber',
    type: 'Property Manager',
    email: 'thomas.w@example.com',
    phone: '+39 331 2233445',
    zone: 'Milano · Navigli',
    apartments: 5,
    activeContract: false,
    hasVikey: false,
  },
]
export const TYPE_STYLE: Record<ReferenteType, string> = {
  Host: 'bg-coral/5 text-coral border-coral/30',
  'Property Manager': 'bg-navy/5 text-navy border-navy/20',
  'B&B': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Agenzia: 'bg-purple-50 text-purple-700 border-purple-200',
}
export function referenteFullName(r: Referente): string {
  return `${r.firstName} ${r.lastName}`
}
export function getReferenteById(
  id: string | undefined,
): Referente | undefined {
  return REFERENTI.find((r) => r.id === id)
}
